import {createFileRoute} from "@tanstack/react-router"
import {watchTransferByIdTqo} from "../../rpc/webrpc-client.gen.ts";
import {Typography} from "@mui/joy";
import {useRefreshableInfallibleQuery} from "../../util/tqrefresh.tsx";
import {useMothership} from "../../tq/tqx.tsx";

export const Route = createFileRoute("/_auth/transfer/$id")({
    component: BundleTransferView
})

function BundleTransferView() {
    const {id} = Route.useParams();
    const mama = useMothership();
    const {data: transfer}
        = useRefreshableInfallibleQuery(watchTransferByIdTqo(mama, {transferId: id}));
    return <Typography>{JSON.stringify(transfer)}</Typography>
}
